import React from "react";
import { Button, Modal } from "react-bootstrap";
import { FaPaperclip } from "react-icons/fa";
import DocumentsPanel from "./DocumentsPanel";

// =======================================================
// 📁 DocumentsModal - Modale réutilisable
// =======================================================

const DocumentsModal = ({
  show,
  onHide,
  module,
  moduleId,
  itemLabel = "",
  title,
  canDelete = true,
  size = "xl",
}) => {
  const computedTitle =
    title || `Documents ${itemLabel ? `- ${itemLabel}` : ""}`.trim();

  return (
    <Modal
      show={show}
      onHide={onHide}
      size={size}
      centered
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <FaPaperclip className="me-2" />
          {computedTitle}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {!module || !moduleId ? (
          <div className="text-center text-muted py-4">
            Aucun élément sélectionné.
          </div>
        ) : (
          <DocumentsPanel
            module={module}
            moduleId={moduleId}
            title={computedTitle}
            canDelete={canDelete}
          />
        )}
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Fermer
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default React.memo(DocumentsModal);